import React from "react";

// ===================================================================
// The Crowd v2 — Nuage de points (correlation de deux mesures)
//
// Composant partage. SVG a largeur fluide (viewBox fixe) ; couleurs via
// les classes v2-nuage-* (v2-composants.css), jamais en dur.
//
// Props :
//   data       [{ ... }]
//   xKey, yKey cles des deux mesures
//   libelle    fn(ligne) -> texte affiche pres du point et en infobulle
//   titreX, titreY   titres des axes
//   formatX, formatY fn(valeur) -> texte de l'infobulle — optionnels
// ===================================================================

const LARGEUR = 640;
const HAUTEUR = 420;
const MARGE = { haut: 30, droite: 30, bas: 56, gauche: 56 };

function GraphiqueNuage({ data, xKey, yKey, libelle, titreX, titreY, formatX = (v) => v, formatY = (v) => v }) {
  if (!data || data.length === 0) return <p className="v2-vide">Aucune donnée</p>;

  const lu = MARGE.gauche;
  const lw = LARGEUR - MARGE.gauche - MARGE.droite;
  const lh = HAUTEUR - MARGE.haut - MARGE.bas;
  const maxX = Math.max(...data.map((d) => d[xKey]), 1);
  const maxY = Math.max(...data.map((d) => d[yKey]), 1);

  const points = data.map((d) => ({
    x: lu + (d[xKey] / maxX) * lw,
    y: MARGE.haut + lh - (d[yKey] / maxY) * lh,
    texte: libelle(d),
    vx: d[xKey],
    vy: d[yKey],
  }));

  return (
    <svg className="v2-nuage" viewBox={`0 0 ${LARGEUR} ${HAUTEUR}`} role="img" aria-label={`${titreY} en fonction de ${titreX}`}>
      {[0, 0.25, 0.5, 0.75, 1].map((r) => {
        const y = MARGE.haut + lh - r * lh;
        const x = lu + r * lw;
        return (
          <g key={r}>
            <line className="v2-nuage-grille" x1={lu} y1={y} x2={LARGEUR - MARGE.droite} y2={y} />
            <line className="v2-nuage-grille" x1={x} y1={MARGE.haut} x2={x} y2={HAUTEUR - MARGE.bas} />
            <text className="v2-nuage-graduation" x={lu - 8} y={y + 4} textAnchor="end">{Math.round(maxY * r)}</text>
            <text className="v2-nuage-graduation" x={x} y={HAUTEUR - MARGE.bas + 20} textAnchor="middle">{Math.round(maxX * r)}</text>
          </g>
        );
      })}

      <text className="v2-nuage-titre" x={lu + lw / 2} y={HAUTEUR - 10} textAnchor="middle">{titreX}</text>
      <text className="v2-nuage-titre" x={16} y={MARGE.haut + lh / 2} textAnchor="middle" transform={`rotate(-90, 16, ${MARGE.haut + lh / 2})`}>
        {titreY}
      </text>

      {points.map((p, i) => (
        <g key={i}>
          <circle className="v2-nuage-point" cx={p.x} cy={p.y} r="6">
            <title>{`${p.texte} : ${formatX(p.vx)}, ${formatY(p.vy)}`}</title>
          </circle>
          <text className="v2-nuage-etiquette" x={p.x} y={p.y - 11} textAnchor="middle">
            {p.texte.split(" ")[0]}
          </text>
        </g>
      ))}
    </svg>
  );
}

export default GraphiqueNuage;
